import { Link } from "react-router-dom";
import { allGenres, allMovies } from "@/lib/movies";

export default function IntroBand() {
  const episodeCount = allMovies.reduce((sum, movie) => sum + (movie.episodes?.length ?? 0), 0);
  const seriesCount = allMovies.filter((movie) => movie.type === "剧集").length;

  const stats = [
    { value: allMovies.length, label: "收录影视作品", suffix: "部" },
    { value: seriesCount, label: "剧集深度解析", suffix: "部" },
    { value: episodeCount, label: "分集剧情条目", suffix: "条" },
    { value: allGenres.length, label: "内容题材分类", suffix: "类" },
  ];

  return (
    <section className="mt-16 md:mt-24 border-y border-background-200/70 bg-background-100">
      <div className="max-w-shell mx-auto px-4 md:px-8 py-12 md:py-16 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <span className="w-4 h-[2px] bg-accent-500"></span>
            <span className="font-label text-[11px] tracking-[0.28em] text-accent-500 uppercase">
              About the Archive
            </span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 leading-snug">
            把一部作品讲透，
            <br className="hidden sm:block" />
            比把它讲完更重要。
          </h2>
          <p className="mt-5 text-sm md:text-base leading-relaxed text-foreground-400">
            淫乱小镇是一个专注影视剧情的内容站。我们不追热点式的快评，而是把每部作品的叙事结构、人物关系与关键转折整理成可读的长文。从电影到剧集，从国产到海外，你可以先看简介，再决定要不要花两个小时。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-500">
            所有内容均为编辑整理的剧情介绍与评论，站内不提供播放、下载等任何形式的资源服务。
          </p>
          <div className="mt-6 flex flex-col sm:flex-row gap-3">
            <Link
              to="/category"
              className="h-11 px-6 inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 text-foreground-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              开始浏览作品库
            </Link>
            <Link
              to="/about"
              className="h-11 px-6 inline-flex items-center justify-center gap-2 rounded-md border border-background-300 text-foreground-200 text-sm hover:border-accent-500 hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              关于本站
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3 md:gap-4">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg border border-background-200/70 bg-background-50/60 p-4 md:p-5"
            >
              <p className="font-label text-2xl md:text-4xl text-foreground-50 leading-none">
                {stat.value}
                <span className="text-sm md:text-base text-accent-500 ml-1">{stat.suffix}</span>
              </p>
              <p className="mt-2.5 text-[11px] md:text-xs text-foreground-500 tracking-wide">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}